import { css } from "@emotion/css";

import { AspectRatioProps } from "../AspectRatio";

type AspectRatioStylesProps = Pick<
  AspectRatioProps,
  "objectFit" | "objectPosition" | "ratio"
>;
export const createAspectRatioStyles = ({
  objectFit,
  objectPosition,
  ratio,
}: AspectRatioStylesProps) => {
  return {
    root: css({
      position: "relative",
      "& > :first-child": {
        position: "absolute",
        top: 0,
        left: 0,
        height: "100%",
        width: "100%",
      },
      // prevents image from loosing its original aspect ratio
      // when the provided aspectRatio ratio doesn't match the ratio of the loaded image
      "& > img": {
        objectFit,
        objectPosition,
      },
      "&::before": {
        content: "''",
        display: "block",
        width: "100%",
        height: 0,
        paddingBottom: `calc(100% / (${ratio}))`,
      },
    }),
  };
};
